<template>
    <div>
        <div :class="{'show': toggleModal }" class="modal fade">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{$t('table.header.gallery')}}
                            <small class="m-0 text-muted">{{$t('table.header.gallery')}} - "{{name}}"</small>
                        </h5>
                        <button type="button" class="close" @click="closeGallery">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body modal-body-lg w-100">
                        <div class="form-group">
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0" >
                                        <i class="fas fa-store"></i>
                                    </label>
                                    <multiselect v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="selectOutlet"></multiselect>
                                </div>
                            </div>
                        </div>
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && gallery.length == 0">{{$t('message.info.no_records_image')}}</div>
                        <div v-if="!isSpinnerShow && gallery.length != 0" class="m-auto">
                            <div class="p-5 panel">
                                <div class="text-right mb-2 mr-2">
                                    <button class="btn btn-sm btn-outline-primary" type="button" title="Delete Image" @click="showDeleteModal">
                                        <span class="fal fa-trash" ></span>
                                    </button>
                                </div>
                                <!-- <lingallery ref="lingallery" class="text-center" 
                                    :items="gallery"
                                    :showThumbnails="true"
                                    :responsive="true"
                                    :disableImageClick="true"
                                    accentColor="#886ab5"
                                    :iid.sync="currentId"
                                /> -->
                                <b-carousel class="text-center w-100 mb-2"
                                    :no-touch="true"
                                    :interval="0"
                                    v-model="slide">
                                    <b-carousel-slide v-for="img in gallery" :key="img.id" >
                                    <template slot="img">
                                        <image-zoom 
                                            :show-message="false"
                                            :regular="img.src" 
                                            img-class="img-fluid">				
                                        </image-zoom>
                                    </template>
                                    </b-carousel-slide>
                                </b-carousel>
                                <div class="thumbnail-container">
                                    <ul class="thumbnail-list">
                                        <li v-for="(img,i) in gallery" :key="img.id">
                                            <div class="thumbnail d-flex align-items-center" :class="{'current-image': i == slide}">
                                                <a class="link" @click="slide = i"><img class="img-fluid" :src="getImage(img.src)"></a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <!-- <div class="row m-auto overflow-auto">
                                    <div class="col-xs-auto" v-for="(img,i) in gallery" :key="img.id">
                                        <div class="thumbnail d-flex align-items-center" :class="{'current-image': i == slide}">
                                            <a class="link" @click="slide = i"><img class="img-fluid" :src="getImage(img.src)"/></a>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                        <h6 class="text-dark fw-500">{{$t('header.upload_image')}}: </h6>
                        <div class="text-right">
                            <p class="mb-1">{{$t('label.max_file_size')}}</p>
                        </div>
                        <div v-if="errorImage.length != 0">
                            <i class="mr-2 fas fa-exclamation-triangle text-danger"></i>
                            <p class="d-inline mb-1">{{$t('label.error_upload')}}</p>
                            <span class="d-block fw-300" v-for="(img, i) in errorImage" :key="i">{{i+ 1}}. [ {{img}} ]</span>
                        </div>
                        <div class="w-100 text-right">
                            <a class="link text-primary" @click="clearDropzone">{{$t('button_link.cancel')}}</a>
                        </div>
                        <vue-dropzone id="dzStaffImage" ref="dropzone" class="text-center mb-5" 
                            :options="dropOptions" 
                            @vdropzone-success="dropLogo" 
                            @vdropzone-error="errorUploadImage"
                            @vdropzone-file-added="fileAdded">
                        </vue-dropzone>
                    </div>
                </div>
            </div>
        </div>
       <deleteModal ref="deleteModal" @performConfirmAction="deleteImage"></deleteModal>
    </div>
</template>
<script>
import DeleteModal from './../../Delete_Modal'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
import vueDropzone from "vue2-dropzone";
import Lingallery from 'lingallery';
import imageZoom from 'vue-image-zoomer';


export default {
    name: "serviceGallery",
    components:{
        vueDropzone, DeleteModal, imageZoom
    },
    data(){
        return{

            toggleModal: false, name: "", memberID: 0, gallery: [], 
            isSpinnerShow: false, addToggle: false, 
            dropOptions: {
                url: this.$api.API_IMAGE,
                // maxFilesize: 2,
                addRemoveLinks: true,
                paramName: 'filename',
                headers:{
                    token: this.$util.getSessionToken()
                }
            },
            slide: 0,
            outlet: [],
            selectedOutlet: {},
            uploadError: false, errorImage: []
        }
    },
    methods:{
        getImage(src){
            return src
        },
        clearDropzone(){
            this.$refs.dropzone.removeAllFiles()
        },
        closeGallery(){
            this.errorImage = []
            this.uploadError = false
            this.toggleModal = false
            this.$refs.dropzone.removeAllFiles()
        },
        async closeModal(isError){
            await this.setGallery()
            this.$refs.deleteModal.toggleModal = false
            this.$parent.$parent.$parent.isModalShow = false;
        },
        selectOutlet(item){
            this.selectedOutlet = item
        },
        editMemberGallery(item){
            this.memberID = item.memberID
            this.name = item.memberDisplayName
            
            this.toggleModal = true
            this.setGallery()
        },
        async setGallery(){
            this.gallery = []
            this.isSpinnerShow = true
            var result = await this.getGallery()
            
            for(var i=0; i<result.length; i++){
                this.gallery.push(
                    {
                        id: result[i].imageID, 
                        src: result[i].imageUrl
                    },
                )
            }

            this.isSpinnerShow = false
        },
        async getGallery(){
            let $vm = this
            let url = this.$api.BIZ_MEMBER + "/" + this.memberID + this.$api.IMAGES

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result
                
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })
            return result
        },
        fileAdded(){
            this.uploadError = false
            this.errorImage = []
        },
        errorUploadImage(file, message){
            if(message.indexOf('File is too big') != -1){
                this.uploadError = true
                this.errorImage.push(file.name)
            }
            this.$refs.dropzone.removeFile(file)
        },
        dropLogo(file, response){
            if(response.path == undefined){
                this.parent.$parent.$parent.setModal(this, false, true, this.$i18n.t('message.error.upload'));
            }
            var data = {
                imageUrl: response.path,
                outletID: this.selectedOutlet.id
            }

            let $vm = this
            let url = this.$api.BIZ_MEMBER + "/" + this.memberID + this.$api.IMAGES
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data
            })
            .then(function(response) {
                if(response.status == 200){
                    // $vm.$parent.$parent.$parent.setModal($vm, false, true, $vm.$i18n.t('message.success.upload'));
                    $vm.validateImageUpload()
                    $vm.gallery = []
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })
            this.$refs.dropzone.removeFile(file)
        },
        validateImageUpload(){
            if(this.uploadError){
                this.$parent.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.max_file_size'));
            }else{
                this.$parent.$parent.$parent.setModal(this, false, true, this.$i18n.t('message.success.upload'));
            }
        },
        showDeleteModal(){
            var title = this.$i18n.t('header.delete_image')
            var message = this.$i18n.t('message.confirmation.delete_image')
            this.$refs.deleteModal.showModal(title, message)
        },
        deleteImage(){
            let $vm = this
            var currentImage = this.gallery[this.slide]

            let QUERY_STRING = currentImage.id + this.$api.DELETE
            let url = this.$api.BIZ_MEMBER + "/" + this.memberID + this.$api.IMAGES + "/" + QUERY_STRING
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
            })
            .then(function(response) {
                if(response.status == 200){
                    $vm.$parent.$parent.$parent.setModal($vm, false, true, $vm.$i18n.t('message.success.delete_image'));
                    if($vm.slide == ($vm.gallery.length-1)){
                        $vm.slide =  $vm.gallery.length - 2
                    }
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })
        },
    },
    mounted(){
        let $vm = this
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];
    },
}
</script>
<style scoped>
.show{
    display: block;
}
.modal-body-lg{
    min-height: 60vh;
    max-height: 65vh;
    overflow-y: auto;
}
.thumbnail-container {
    overflow-x:scroll;
    width:100%;
    padding: 0 15px;
}
.thumbnail-list {
    white-space:nowrap;
    list-style: none;
}
.thumbnail-list li {
  display: inline-block;
}
.thumbnail {
    margin-left: .25em;
    margin-right: .25em;
    width: 60px;
    height: 60px;
    overflow: hidden;
}
.current-image{
    border: 3px solid rgb(206, 202, 202);;
} 
@media only screen and (min-width: 992px) {
    .modal-body-lg{
        padding-left: 5em !important;
        padding-right: 5em !important;
    }
}
</style>